import { Box, Modal, Rating, TextField } from '@mui/material';
import Leaflet from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import 'leaflet/dist/leaflet.css';
import { useEffect, useMemo, useState } from 'react';
import { FaDirections } from 'react-icons/fa';
import { MapContainer, Marker, TileLayer } from 'react-leaflet';
import { getComments, newComment, sendVerificationSms, verifyCode } from '../api/routes';
import RTLInput from './RTLInput';
import ReactInputVerificationCode from "react-input-verification-code";
import { toast } from 'react-toastify';

let DefaultIcon = Leaflet.icon({ iconUrl: icon, shadowUrl: iconShadow });
Leaflet.Marker.prototype.options.icon = DefaultIcon;

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '94%', sm: 520 },
    bgcolor: 'transparent',
    boxShadow: 'none',
    p: 0,
};

export default function ContactUs({ data }) {
    const selectedPosition = [36.29337144002341, 59.57897543907166];

    const [open, setOpen] = useState(false);
    const handleClose = () => { setOpen(false); setStep(1); setCode(''); };
    const handleOpen = () => setOpen(true);

    const [text, setText] = useState('');
    const [loading, setLoading] = useState(false);

    const [star, setStar] = useState('');
    const [step, setStep] = useState(1);
    const [code, setCode] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');

    const [comments, setComments] = useState([]);

    const persianTextRegex = /^[. 0-9 ، آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیئ\s]+$/;

    const mapOptions = useMemo(() => ({
        doubleClickZoom: false,
        closePopupOnClick: false,
        dragging: false,
        zoomSnap: false,
        zoomDelta: false,
        trackResize: false,
        touchZoom: false,
        scrollWheelZoom: false,
    }), []);

    useEffect(() => {
        getComments((isOk, data) => {
            if (!isOk) return alert(data.message);
            setComments(data || []);
        })
    }, []);

    const textChange = (event) => {
        const v = event.target.value;
        if (v === '') return setText(v);
        if (v.match(persianTextRegex)) return setText(v);
        return toast.error('متن پیام باید فارسی باشد!');
    };

    const sendSMS = () => {
        if (!phoneNumber || !phoneNumber.match(/^(09)[0-9]{9}$/)) {
            return toast.error('شماره موبایل معتبر نیست');
        }
        setLoading(true);
        sendVerificationSms({ phone_number: phoneNumber }, (isOk, res) => {
            setLoading(false);
            if (!isOk) return toast.error(res.message);
            toast.success('کد تایید ارسال شد');
            setStep(2);
        })
    };

    const submitCode = () => {
        if (!code || code?.length !== 5) return;
        setLoading(true);
        verifyCode({ phone_number: phoneNumber, code }, (isOk, res) => {
            setLoading(false);
            if (!isOk) return toast.error(res.message);
            setStep(3);
        })
    };

    const submitComment = () => {
        if (!text || text.trim() === '' || star === '') return toast.error('تمام مقادیر را پر کنید!');
        setLoading(true);
        newComment({ text, rating: star }, (isOk, res) => {
            setLoading(false);
            if (!isOk) return toast.error(res.message);
            toast.success('نظر شما ثبت شد!');
            setText('');
            setStar('');
            handleClose();

            // refresh comments (optional)
            getComments((ok2, data2) => {
                if (ok2) setComments(data2 || []);
            });
        })
    };

    const StepPill = ({ active, label, index }) => (
        <div className={`flex items-center gap-2 px-3 py-2 rounded-2xl border 
      ${active ? 'bg-white/80 border-white/70 shadow-sm' : 'bg-white/50 border-white/50 opacity-70'}`}>
            <span className={`w-7 h-7 rounded-xl grid place-items-center text-xs font-black
        ${active ? 'bg-[#e8fbff] text-[#0284c7] ring-1 ring-[#bfefff]' : 'bg-white/70 text-slate-600 ring-1 ring-black/5'}`}>
                {index}
            </span>
            <span className="text-xs font-extrabold text-slate-700">{label}</span>
        </div>
    );

    const step1 = () => (
        <>
            <p className="text-sm sm:text-base font-extrabold text-slate-900">ثبت نظر</p>
            <p className="mt-1 text-xs sm:text-sm text-slate-600 leading-6">
                برای ثبت نظر، ابتدا شماره موبایل خود را وارد کنید.
            </p>

            <div className="mt-5">
                <TextField
                    label="شماره موبایل"
                    placeholder="0912xxxxxxxx"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    fullWidth
                    type="tel"
               
                />
            </div>

            <button
                disabled={loading}
                onClick={sendSMS}
                className="mt-5 w-full h-[48px] rounded-2xl font-extrabold text-white
                   bg-gradient-to-r from-[#06b6d4] to-[#0284c7]
                   shadow-md hover:shadow-lg transition disabled:opacity-60"
            >
                دریافت کد تایید
            </button>
        </>
    );

    const step2 = () => (
        <>
            <p className="text-sm sm:text-base font-extrabold text-slate-900">تایید شماره</p>
            <p className="mt-1 text-xs sm:text-sm text-slate-600 leading-6">
                کد ارسال‌شده به شماره <span className="font-extrabold text-slate-800">{phoneNumber}</span> را وارد کنید.
            </p>

            <div className="mt-5 rounded-2xl bg-white/70 border border-white/60 p-4">
                <div className="custom-styles" style={{ direction: 'ltr' }}>
                    <ReactInputVerificationCode
                        value={code}
                        autoFocus
                        placeholder=""
                        length={5}
                        onChange={setCode}
                    />
                </div>
            </div>

            <div className="mt-5 flex gap-3">
                <button
                    disabled={loading || code?.length !== 5}
                    onClick={submitCode}
                    className="w-full h-[48px] rounded-2xl font-extrabold text-white
                     bg-gradient-to-r from-[#06b6d4] to-[#0284c7]
                     shadow-md hover:shadow-lg transition disabled:opacity-60"
                >
                    تایید
                </button>

                <button
                    disabled={loading}
                    onClick={() => setStep(1)}
                    className="w-full h-[48px] rounded-2xl font-extrabold text-slate-700
                     bg-white/80 border border-slate-200 shadow-sm hover:shadow-md transition"
                >
                    ویرایش
                </button>
            </div>
        </>
    );

    const step3 = () => (
        <>
            <p className="text-sm sm:text-base font-extrabold text-slate-900">ثبت نظر شما</p>
            <p className="mt-1 text-xs sm:text-sm text-slate-600 leading-6">
                لطفاً امتیاز و متن نظر خود را وارد کنید.
            </p>

            <div className="mt-5">
                <TextField
                    multiline
                    rows={5}
                    label="متن نظر"
                    value={text}
                    onChange={textChange}
                    fullWidth
                    variant="filled"
                    InputProps={{ disableUnderline: true }}
                    sx={{
                        '& .MuiFilledInput-root': {
                            borderRadius: '18px',
                            backgroundColor: 'rgba(255,255,255,0.75)',
                        },
                    }}
                />
            </div>

            <div className="mt-5 flex items-center justify-between flex-wrap gap-3">
                <div className="flex items-center gap-3">
                    <span className="text-xs font-extrabold text-slate-700">امتیاز:</span>
                    <Rating
                        value={star === '' ? 0 : star}
                        onChange={(_e, v) => setStar(v)}
                    />
                </div>

                <span className="text-xs font-bold text-slate-500">
                    لطفاً محترمانه و کوتاه بنویسید.
                </span>
            </div>

            <button
                disabled={loading}
                onClick={submitComment}
                className="mt-6 w-full h-[48px] rounded-2xl font-extrabold text-white
                   bg-gradient-to-r from-[#06b6d4] to-[#0284c7]
                   shadow-md hover:shadow-lg transition disabled:opacity-60"
            >
                ارسال نظر
            </button>
        </>
    );

    return (
        <div className="relative bg-white overflow-hidden py-24" id="contactUs">
     
            <div className="container mx-auto px-4">
                {/* heading */}
                <section className="flex flex-col items-center">
                    <span className="px-5 py-2 rounded-full text-xs font-extrabold bg-[#0ea5b7] text-white shadow-md">
                        ارتباط با مرکز
                    </span>

                    <h2 className="mt-5 text-center text-2xl sm:text-3xl font-black text-slate-900 tracking-tight">
                        تماس با ما و نظرات مراجعین
                    </h2>

                    <div className="mt-4 h-[3px] w-16 rounded-full bg-gradient-to-r from-[#06b6d4] via-[#22c55e] to-[#3b82f6]" />

                    <p className="text-center text-sm sm:text-base mt-6 text-slate-600 max-w-2xl leading-7">
                        اطلاعات تماس و مسیر‌یابی مرکز را ببینید و تجربه‌ی خود را با دیگران به اشتراک بگذارید.
                    </p>
                </section>



                {/* ===================== ROW 2: COMMENTS ===================== */}
                <section className="mt-10 rounded-[34px] bg-white/70 backdrop-blur-xl border border-white/60
                           ring-1 ring-black/5 overflow-hidden">
                    {/* header row */}
                    <div className="px-6 sm:px-8 py-6 flex items-center justify-between flex-wrap gap-3">
                        <div>
                            <p className="text-base sm:text-lg font-black text-slate-900">نظرات مراجعین</p>
                            <p className="mt-1 text-xs sm:text-sm text-slate-600">
                                تجربه‌ی شما به بهتر شدن خدمات کمک می‌کند.
                            </p>
                        </div>

                        <button
                            onClick={handleOpen}
                            className="h-[44px] px-5 rounded-2xl font-extrabold text-white
                       bg-gradient-to-r from-[#06b6d4] to-[#0284c7]
                       shadow-md hover:shadow-lg transition inline-flex items-center gap-2"
                        >
                            ✍️ ثبت نظر
                            <span className="opacity-90">←</span>
                        </button>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-0">
                        {/* summary */}
                        <div className="px-6 sm:px-8 pb-6 lg:pb-10 lg:border-l lg:border-slate-200/60">
                            <div className="rounded-[26px] bg-white/60 border border-white/60 ring-1 ring-black/5 p-5">
                                <p className="text-xs font-extrabold text-slate-700">امتیاز کلی</p>

                                <div className="mt-3 flex items-end justify-between">
                                    <div>
                                        <p className="text-3xl font-black text-[#0ea5b7] leading-none">
                                            {comments?.length
                                                ? (comments.reduce((s, c) => s + (Number(c.rating) || 0), 0) / comments.length).toFixed(1)
                                                : '0.0'}
                                        </p>
                                        <p className="text-[11px] text-slate-500 mt-1">
                                            {comments?.length ? `${comments.length} نظر ثبت شده` : 'هنوز نظری ثبت نشده'}
                                        </p>
                                    </div>

                                    <Rating
                                        readOnly
                                        value={
                                            comments?.length
                                                ? (comments.reduce((s, c) => s + (Number(c.rating) || 0), 0) / comments.length)
                                                : 0
                                        }
                                        precision={0.1}
                                        size="small"
                                    />
                                </div>

                                <div className="mt-5 h-2 w-full rounded-full bg-gradient-to-r from-[#06b6d4] via-[#22c55e] to-[#3b82f6] opacity-55" />
                            </div>
                        </div>

                        {/* list */}
                        <div className="lg:col-span-2 px-6 sm:px-8 pb-8 lg:pb-10">
                            <div className="rounded-[26px] bg-white/60 border border-white/60 ring-1 ring-black/5 overflow-hidden">
                                <div className="h-2 w-full bg-gradient-to-r from-[#06b6d4] via-[#22c55e] to-[#3b82f6] opacity-70" />

                                <div className="max-h-[380px] overflow-y-auto p-4 sm:p-5 space-y-4">
                                    {comments?.length ? comments.map((comment, idx) => {
                                        const date = `${String(comment.createdAt).slice(0, 4)}/${String(comment.createdAt).slice(4, 6)}/${String(comment.createdAt).slice(6)}`;
                                        const isAlt = idx % 2 === 0;

                                        return (
                                            <div key={comment.commentId} className={`flex ${isAlt ? 'justify-start' : 'justify-end'}`}>
                                                <div className={`relative max-w-[92%] sm:max-w-[85%] rounded-[22px] p-4
                                      ${isAlt
                                                        ? 'bg-white/85 border border-white/60'
                                                        : 'bg-[#e8fbff]/70 border border-[#bfefff]/60'}
                                      shadow-[0_12px_40px_rgba(2,132,199,0.10)] ring-1 ring-black/5`}>
                                                    <div className={`absolute top-3 ${isAlt ? '-left-1' : '-right-1'} w-3 h-3 rotate-45
                                        ${isAlt
                                                            ? 'bg-white/85 border-l border-t border-white/60'
                                                            : 'bg-[#e8fbff]/70 border-l border-t border-[#bfefff]/60'}`} />

                                                    <div className="flex items-center justify-between gap-3">
                                                        <Rating value={Number(comment.rating) || 0} readOnly size="small" />
                                                        <span className="text-[11px] text-slate-400 whitespace-nowrap">{date}</span>
                                                    </div>

                                                    <p className="mt-2 text-sm sm:text-[15px] text-slate-700 leading-7">
                                                        {comment.text}
                                                    </p>
                                                </div>
                                            </div>
                                        );
                                    }) : (
                                        <div className="py-12 text-center">
                                            <div className="mx-auto w-14 h-14 rounded-3xl bg-white/80 border border-white/60 shadow-sm grid place-items-center">
                                                💬
                                            </div>
                                            <p className="mt-4 text-sm sm:text-base font-extrabold text-slate-800">
                                                هنوز نظری ثبت نشده است
                                            </p>
                                            <p className="mt-1 text-xs sm:text-sm text-slate-600">
                                                شما می‌توانید اولین نظر را ثبت کنید.
                                            </p>
                                        </div>
                                    )}
                                </div>

                                <div className="h-2 w-full bg-gradient-to-r from-[#06b6d4] via-[#22c55e] to-[#3b82f6] opacity-35" />
                            </div>
                        </div>
                    </div>
                </section>
                {/* ===================== ROW 1: CONTACT ===================== */}
                <section className="mt-12 rounded-[34px] bg-white/70 backdrop-blur-xl border border-white/60
                          shadow-[0_28px_110px_rgba(2,132,199,0.12)] ring-1 ring-black/5 overflow-hidden">
                    {/* header row */}
                    <div className="px-6 sm:px-8 py-6 flex items-center justify-between flex-wrap gap-3">
                        <div>
                            <p className="text-base sm:text-lg font-black text-slate-900">تماس با ما</p>
                            <p className="mt-1 text-xs sm:text-sm text-slate-600">
                                آدرس، تلفن و ساعات کاری مرکز
                            </p>
                        </div>

                        <a
                            href="https://www.google.com/maps/dir/?api=1&destination=36.29337144002341,59.57897543907166&travelmode=driving"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 px-4 py-2 rounded-2xl text-xs font-extrabold
                       bg-white/85 border border-slate-200 shadow-sm hover:shadow-md transition text-slate-700"
                        >
                            <FaDirections />
                            مسیر‌یابی
                        </a>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
                        {/* info */}
                        <div className="px-6 sm:px-8 pb-8 lg:pb-10">
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2">
                                <div className="rounded-2xl bg-white/60 border border-white/60 ring-1 ring-black/5 p-4">
                                    <p className="text-xs font-extrabold text-slate-700">آدرس</p>
                                    <p className="mt-2 text-sm sm:text-base text-slate-600 leading-7">
                                        {data ? data.AddressDep : ''}
                                    </p>
                                </div>

                                <div className="rounded-2xl bg-white/60 border border-white/60 ring-1 ring-black/5 p-4">
                                    <p className="text-xs font-extrabold text-slate-700">شماره تماس</p>
                                    <p className="mt-2 text-sm sm:text-base text-slate-600 leading-7">
                                        {data ? data.TelDep : ''}
                                    </p>
                                </div>

                                <div className="sm:col-span-2 rounded-2xl bg-white/60 border border-white/60 ring-1 ring-black/5 p-4">
                                    <p className="text-xs font-extrabold text-slate-700">ساعات کاری</p>
                                    <p className="mt-2 text-sm sm:text-base text-slate-600 leading-7">
                                        {data ? data.workingTime : ''}
                                    </p>
                                </div>
                            </div>

                            {/* accent strip */}
                            <div className="mt-6 h-2 w-full rounded-full bg-gradient-to-r from-[#06b6d4] via-[#22c55e] to-[#3b82f6] opacity-60" />
                        </div>

                        {/* map */}
                        <div className="relative">
                            <div className="h-[300px] sm:h-[360px] lg:h-full min-h-[320px]">
                                <MapContainer {...mapOptions} center={selectedPosition} zoom={16} className="w-full h-full">
                                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                    <Marker position={selectedPosition} />
                                </MapContainer>
                            </div>
                            <div className="absolute inset-x-0 bottom-0 h-2 bg-gradient-to-r from-[#06b6d4] via-[#22c55e] to-[#3b82f6]" />

                            {/* small direction badge */}
                            <a
                                href="https://www.google.com/maps/dir/?api=1&destination=36.29337144002341,59.57897543907166&travelmode=driving"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="absolute bottom-4 right-4 rounded-2xl px-4 py-3 bg-white/90 backdrop-blur-xl
                         border border-white/60 shadow-lg text-slate-700 text-xs font-extrabold
                         inline-flex items-center gap-2"
                            >
                                <FaDirections />
                                مسیریابی
                            </a>
                        </div>
                    </div>
                </section>
            </div>

            {/* Modal */}
            <Modal open={open} onClose={handleClose}>
                <Box sx={modalStyle}>
                    <RTLInput>
                        <div className="rounded-[28px] bg-white/80 backdrop-blur-xl border border-white/60
                          shadow-[0_30px_120px_rgba(2,132,199,0.16)] ring-1 ring-black/5 p-6 sm:p-7">

                            <div className="flex items-center justify-between">
                                <p className="text-base sm:text-lg font-black text-slate-900">ثبت نظر</p>
                                <button
                                    onClick={handleClose}
                                    className="w-10 h-10 rounded-2xl bg-white/80 border border-slate-200 shadow-sm hover:shadow-md transition grid place-items-center text-slate-600"
                                >
                                    ✕
                                </button>
                            </div>

                            <div className="mt-4 grid grid-cols-3 gap-2">
                                <StepPill index={1} label="شماره" active={step === 1} />
                                <StepPill index={2} label="کد" active={step === 2} />
                                <StepPill index={3} label="نظر" active={step === 3} />
                            </div>

                            <div className="mt-6">
                                {step === 1 ? step1() : step === 2 ? step2() : step3()}
                            </div>
                        </div>
                    </RTLInput>
                </Box>
            </Modal>
        </div>
    );
}
